import { formatInTimeZone } from 'date-fns-tz';
import es from 'date-fns/locale/es';
import ptBR from 'date-fns/locale/pt-BR';
import { timeZoneOptions } from 'I18n/types';

export const formatDateByRegion = (
	date: Date,
	timeZoneString: timeZoneOptions,
	formatStr?: string,
) => {
	const localeByTimeZone = {
		'America/Mexico_City': {
			language: es,
			defaultFormat: 'dd/mm/yyyy h:mm:ss',
		},
		'America/Sao_Paulo': {
			language: ptBR,
			defaultFormat: 'dd/mm/yyyy h:mm:ss',
		},
	}[timeZoneString];

	const timeZoneFormatter = formatStr || localeByTimeZone.defaultFormat;

	return formatInTimeZone(date, timeZoneString, timeZoneFormatter, {
		locale: localeByTimeZone.language,
	});
};
